export default {
  name: "exclamation_circle",
  class: "h-6 w-6 text-red-400",
  box: 24,
  svg: `<path
  stroke-linecap="round"
  stroke-linejoin="round"
  stroke-width="2"
  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="fillcolor"
/>`,
};
